const styles = {
  card: {
    gridColumn: 'span 3',            
    gridRow: 1,
    p: 0.5,                          
    backgroundColor: '#fff',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflow: 'visible',
    borderRadius: 0,
    boxShadow: 'none',
  },

  chartRoot: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    flexGrow: 1,
  },

  chartText: {
    '& .recharts-text': {
      fontSize: 'clamp(9px, 1.1vw, 12px)',
    },
  },

  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',  
    px: 1.5,
    mt: 0.5,
  },
  headerTitle: {
    fontSize: '1rem',
    textAlign: 'center',
  },

  chartContainer: {
    flexGrow: 1,
    minHeight: 0,
    overflow: 'visible',
    border: '5px solid #fff',
    borderRadius: 0,
    boxSizing: 'border-box',
    backgroundColor: '#fff',
  },

  inlineLegend: {
    display: 'flex',
    gap: 1.5,
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  inlineLegendItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 0.5,
  },
  inlineLegendSwatch: { width: 10, height: 10, borderRadius: 4 },
  inlineLegendText: { fontSize: 11, opacity: 0.85 },
};

export default styles;
